import FactModalView from './FactModalView';

export default FactModalView;
